<div class="layer-catalog-item" style="padding-top:4px; display:inline-block;" *ngIf="layerCatalogItem">
    <div class="row">
        <div class="checkbox-container" *ngIf="layerCatalogItem.layer">
            <input type="checkbox" [(ngModel)]="layerCatalogItem.isSelected" (change)="checkChanged()">
        </div>
        <div class="expand-collapse" *ngIf="!layerCatalogItem.layer" (click)="toggle()">
            <i class="icon-ui-plus" *ngIf="!layerCatalogItem.expanded"></i>
            <i class="icon-ui-minus" *ngIf="layerCatalogItem.expanded"></i>
        </div>
        <i class="icon-ui-share shared-map" *ngIf="layerCatalogItem.shareType === 2" title="Shared Layer"></i>
        <div class="name" (click)="toggle()" [attr.title]="layerCatalogItem.id">
            {{ layerCatalogItem.name }}
        </div>
        <div class="details-toggle" style="margin-left:7px; align-content:center;" (click)="toggleDetails()" *ngIf="layerCatalogItem.layer && !layerCatalogItem.ispetl">
            <i class="icon-ui-down" *ngIf="!detailsExpanded"></i>
            <i class="icon-ui-up" *ngIf="detailsExpanded"></i>
        </div>
    </div>
    <div class="details" *ngIf="layerCatalogItem.layer && detailsExpanded">
        <div *ngIf="loading">Loading...</div>
        <div *ngIf="error" class="alert alert-yellow is-active">An error occured when trying to load the layer data</div>
        <div class="data" *ngIf="layerData">
            <div *ngIf="layerData.description">
                <strong>Description:</strong><br />
                <p>{{ layerData.description }}</p>
            </div>
            <div *ngIf="layerData.url">
                <strong>URL:</strong><br />
                <a href="{{layerData.url}}" target="_blank" rel="noopener">{{ layerData.url }}</a>
            </div>
            <div *ngIf="layerData.featureEndpoints && layerData.featureEndpoints.length">
                <strong>URL:</strong><br />
                <ng-template ngFor let-endpoint [ngForOf]="layerData.featureEndpoints" let-i="index">
                    <a href="{{endpoint.url}}" target="_blank" rel="noopener">{{ endpoint.url }}</a><br *ngIf="i === layerData.featureEndpoints.length - 1" />
                </ng-template>
            </div>
            <div *ngIf="layerData.tableNames && layerData.tableNames.length" title="Tables">
                <strong>Tables:</strong>
                <ul>
                    <li *ngFor="let name of layerData.tableNames">{{ name }}</li>
                </ul>
            </div>
            <div *ngIf="layerData.maximumRecordUpdateDate" title="The maximum date of the layer table's recordUpdate field.">
                <strong>Records Last Updated:</strong> {{ layerData.maximumRecordUpdateDate }}
            </div>
            <div *ngIf="layerData.recordCount" title="Record Count">
                <strong>Total Records:</strong> {{ layerData.recordCount }}
            </div>
            <div *ngIf="layerData.sql" title="Layer SQL">
                <strong>SQL Query:</strong><br />
                {{ layerData.sql }}
            </div>
        </div>
    </div>
    <div class="child-list"
        *ngIf="layerCatalogItem.expanded && layerCatalogItem.layerCatalogItems && layerCatalogItem.layerCatalogItems.length">
        <ul class="list-plain layer-list">
            <li class="clearfix" *ngFor="let layerCatalogItem of layerCatalogItem.layerCatalogItems">
                <mc-layer-catalog-item-ng [layerCatalogItem]="layerCatalogItem" [layerItemType]="layerItemType"
                    [multiSelectActive]="false" (checkChangedEvent)="itemSelectedChanged($event)"></mc-layer-catalog-item-ng>
            </li>
        </ul>
    </div>
    <div class="child-list"
        *ngIf="layerCatalogItem.expanded && (!layerCatalogItem.layerCatalogItems || !layerCatalogItem.layerCatalogItems.length)">
        <div style="padding: 5px 0 0 15px;">No results for this category.</div>
    </div>
</div>
